export enum TransportType {
  // we only need the one in this context
  WEBRTC = 'WEBRTC'
}

export interface NodeState {
  upCapacity: number;
  midCapacity: number;
  downCapacity: number;
}

export interface PeeringProtocol {
  type: TransportType;
  majorVersion: number;
  minorVersion: number;
  uris: string[];
}

export interface Cluster {
  id: string;
  transportType: TransportType;
  protocolMajorVersion: number;
  maxDepth: number;
}

export interface Attachment {
  activeCluster: Cluster;
  upstreams: string[];
  depth: number;
}

// Renamed from Node because of the other Node class
export interface NodeData {
  id: string;
  agentId: string;
  tenantId: string;
  contentId: string;
  attachment?: Attachment;
  protocol: PeeringProtocol;
  locality: string;
  state: NodeState;
}

export interface AttachmentRequest {
  node: NodeData;
}

export interface Detach {
  nodeId: string;
  clusterId: string;
}
